import React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from 'src/component/ds/utils';

/* "Switch - Vega" in Figma: 33x18 track, 16x16 thumb at a 1px inset, giving
 * the 14.5px travel below.
 *
 * UNVERIFIED: disabled here is a blanket opacity-50, so a disabled-checked
 * switch is dimmed primary. Figma reportedly shows the unchecked track colour
 * instead -- not confirmed against the file, and grey-when-disabled is a normal
 * convention, so don't assume Figma is wrong. Checkbox and radio share the same
 * blanket treatment; if Figma wins, all three need an explicit rule. */
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'ds-peer ds-inline-flex ds-h-[18px] ds-w-[33px] ds-shrink-0 ds-items-center',
      'ds-rounded-full ds-p-px ds-transition-colors',
      'focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      'disabled:ds-cursor-default disabled:ds-opacity-50',
      'data-[state=unchecked]:ds-bg-muted data-[state=checked]:ds-bg-primary',
      className
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        'ds-pointer-events-none ds-block ds-h-4 ds-w-4 ds-rounded-full',
        'ds-bg-primary-foreground ds-shadow-ds-2xs ds-transition-transform',
        'data-[state=unchecked]:ds-translate-x-0 data-[state=checked]:ds-translate-x-[14.5px]'
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
